import React, { useState, useEffect } from 'react';
import { getPublicTrainings } from '../services/api';
import { useNavigate } from 'react-router-dom';

const DynamicTraining = ({ onEnrollClick }) => {
  const [trainings, setTrainings] = useState([]);
  const [sectionContent, setSectionContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [hoveredButton, setHoveredButton] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchTrainings();
  }, []);

  const fetchTrainings = async () => {
    try {
      const response = await getPublicTrainings();
      console.log('Trainings API Response:', response);
      
      let trainingsData = [];
      if (response && response.data && Array.isArray(response.data)) {
        trainingsData = response.data;
      } else if (response && Array.isArray(response)) {
        trainingsData = response;
      } else if (response && response.trainings && Array.isArray(response.trainings)) {
        trainingsData = response.trainings;
      }
      
      const activeTrainings = trainingsData
        .filter(t => t.isActive !== false)
        .sort((a, b) => (a.order || 0) - (b.order || 0));
      
      setTrainings(activeTrainings);
      console.log('Trainings loaded:', activeTrainings.length);
      
      const sectionResponse = await fetch('https://inteliheads.in/api/cms/public/content/training');
      const sectionDataResponse = await sectionResponse.json();
      if (sectionDataResponse && sectionDataResponse.data) {
        setSectionContent(sectionDataResponse.data);
      } else if (sectionDataResponse && sectionDataResponse._id) {
        setSectionContent(sectionDataResponse);
      }
      
    } catch (error) {
      console.error('Error fetching trainings:', error);
    } finally {
      setLoading(false);
    }
  };

  const getFullImageUrl = (url) => {
    if (!url) return '';
    if (url.startsWith('http')) return url;
    if (url.startsWith('/uploads')) return `https://inteliheads.in${url}`;
    return url;
  };

  const handleViewDetails = (training) => {
    navigate(`/resource/trainings/${training._id}`, { 
      state: { item: training, type: 'trainings' } 
    });
  };

  const handleViewAllTrainings = () => {
    navigate('/resources', { state: { activeTab: 'trainings' } });
  };

  if (loading) {
    return (
      <section style={{ padding: '5rem 0', textAlign: 'center', background: '#FFFFFF' }}>
        <div className="container">
          <i className="fas fa-spinner fa-spin" style={{ fontSize: '2rem', color: '#2C7A7B' }}></i>
          <p style={{ marginTop: '1rem', color: '#5A6E7F' }}>Loading training courses...</p>
        </div>
      </section>
    );
  }

  const title = sectionContent?.title || 'Professional Training & Certification';
  const backgroundColor = sectionContent?.backgroundColor || '#FFFFFF';
  const buttonText = sectionContent?.buttonText || 'Browse All Courses';

  return (
    <section id="training" style={{
      padding: 'clamp(2rem, 6vw, 4rem) 0',
      background: backgroundColor,
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Pattern */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        opacity: 0.03,
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath fill='%230A192F' d='M0,0 L1000,0 L1000,1000 L0,1000 Z M200,200 L800,200 L800,800 L200,800 Z'/%3E%3Ccircle cx='500' cy='500' r='150'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'repeat',
        backgroundSize: '50px'
      }} />
      
      <div className="container" style={{ position: 'relative', zIndex: 1 }}>
        {/* Section Header */}
        <div style={{
          textAlign: 'center',
          marginBottom: 'clamp(1.5rem, 4vw, 2.5rem)'
        }}>
          <h2 style={{
            fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
            marginBottom: '0.5rem',
            color: '#0A192F',
            fontWeight: 700,
            letterSpacing: '-0.02em'
          }}>
            {title}
          </h2>
          
          <div style={{
            width: '60px',
            height: '3px',
            background: '#2C7A7B',
            margin: '0.75rem auto',
            borderRadius: '2px'
          }} />
          
          {/* Browse All Courses Button */}
          {trainings.length > 0 && (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              marginTop: '0.75rem'
            }}>
              <button
                onClick={handleViewAllTrainings}
                onMouseEnter={() => setHoveredButton(true)}
                onMouseLeave={() => setHoveredButton(false)}
                style={{
                  position: 'relative',
                  padding: '0.7rem 1.8rem',
                  background: hoveredButton ? 'transparent' : 'linear-gradient(135deg, #F5A623 0%, #E67E22 100%)',
                  color: hoveredButton ? '#F5A623' : 'white',
                  border: hoveredButton ? '2px solid #F5A623' : 'none',
                  borderRadius: '50px',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  overflow: 'hidden',
                  boxShadow: hoveredButton ? 'none' : '0 4px 15px rgba(245,166,35,0.3)'
                }}
              >
                <span style={{
                  position: 'absolute',
                  top: 0,
                  left: '-100%',
                  width: '100%',
                  height: '100%',
                  background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.3), transparent)',
                  animation: hoveredButton ? 'shimmer 1.5s infinite' : 'none'
                }} />
                <i className="fas fa-graduation-cap" style={{ fontSize: '1rem' }}></i>
                <span>{buttonText}</span>
                <i className="fas fa-arrow-right" style={{ 
                  fontSize: '0.85rem',
                  transition: 'transform 0.3s ease',
                  transform: hoveredButton ? 'translateX(5px)' : 'translateX(0)'
                }}></i>
              </button>
            </div>
          )}
        </div>

        {trainings.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '4rem', background: '#F7F9FC', borderRadius: '24px' }}>
            <i className="fas fa-graduation-cap" style={{ fontSize: '4rem', color: '#CBD5E1', marginBottom: '1rem' }}></i>
            <p style={{ color: '#5A6E7F', fontSize: '1.1rem' }}>No training courses available at the moment.</p>
          </div>
        ) : (
          // Training Cards Grid
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
            gap: 'clamp(1.5rem, 3vw, 2rem)',
            marginBottom: 'clamp(2rem, 5vw, 3rem)'
          }}>
            {trainings.map((training, index) => {
              const getLevelBadge = (level) => {
                const styles = {
                  beginner: { bg: '#E3F2FD', color: '#2196F3', label: 'Beginner' },
                  intermediate: { bg: '#FFF3E0', color: '#FF9800', label: 'Intermediate' },
                  advanced: { bg: '#FEE2E2', color: '#DC2626', label: 'Advanced' }
                };
                return styles[level?.toLowerCase()] || styles.beginner;
              };
              
              const levelBadge = getLevelBadge(training.level);
              
              return (
                <div
                  key={training._id || index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                  style={{
                    background: 'white',
                    borderRadius: '20px',
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    border: '1px solid rgba(44,122,123,0.1)',
                    cursor: 'pointer',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0' // Remove padding from card
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
                    e.currentTarget.style.borderColor = '#2C7A7B';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 10px 30px rgba(0,0,0,0.08)';
                    e.currentTarget.style.borderColor = 'rgba(44,122,123,0.1)';
                  }}
                >
                  {/* Full Image Container */}
                  <div style={{
                    position: 'relative',
                    width: '100%',
                    minHeight: '250px',
                    maxHeight: '320px',
                    height: 'auto',
                    overflow: 'hidden',
                    background: 'linear-gradient(135deg, #F7F9FC 0%, #E2E8F0 100%)'
                  }}>
                    {training.imageUrl ? (
                      <img 
                        src={getFullImageUrl(training.imageUrl)} 
                        alt={training.name}
                        style={{
                          width: '100%',
                          height: '100%',
                          minHeight: '250px',
                          maxHeight: '320px',
                          objectFit: 'cover',
                          transition: 'transform 0.5s ease',
                          display: 'block'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                        onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                        onError={(e) => {
                          e.target.style.display = 'none';
                          const parent = e.target.parentElement;
                          if (parent) {
                            parent.style.background = 'linear-gradient(135deg, #F5A623 0%, #E67E22 100%)';
                            parent.innerHTML = `<div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; font-size: 4rem; color: white;">🎓</div>`;
                          }
                        }}
                      />
                    ) : (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        minHeight: '250px',
                        maxHeight: '320px',
                        fontSize: '4rem',
                        background: 'linear-gradient(135deg, #F5A623 0%, #E67E22 100%)',
                        color: 'white'
                      }}>
                        🎓
                      </div>
                    )}
                    
                    {/* Level Badge */}
                    {training.level && (
                      <div style={{
                        position: 'absolute',
                        top: '12px',
                        right: '12px',
                        background: levelBadge.bg,
                        color: levelBadge.color,
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '0.7rem',
                        fontWeight: 600,
                        backdropFilter: 'blur(8px)',
                        zIndex: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                      }}>
                        {levelBadge.label}
                      </div>
                    )}
                    
                    {/* Category Badge */}
                    {training.category && (
                      <div style={{
                        position: 'absolute',
                        top: '12px',
                        left: '12px',
                        background: 'rgba(44,122,123,0.9)',
                        backdropFilter: 'blur(8px)',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '0.65rem',
                        color: 'white',
                        fontWeight: 600,
                        zIndex: 2,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                      }}>
                        {training.category}
                      </div>
                    )}
                    
                    {/* Duration Badge */}
                    {training.duration && (
                      <div style={{
                        position: 'absolute',
                        bottom: '12px',
                        left: '12px',
                        background: 'rgba(0,0,0,0.6)',
                        backdropFilter: 'blur(8px)',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '0.65rem',
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.3rem',
                        zIndex: 2
                      }}>
                        <i className="fas fa-clock"></i>
                        <span>{training.duration}</span>
                      </div>
                    )}
                    
                    {/* Price Badge */}
                    {training.price && (
                      <div style={{
                        position: 'absolute',
                        bottom: '12px',
                        right: '12px',
                        background: 'rgba(44,122,123,0.9)',
                        backdropFilter: 'blur(8px)',
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '0.75rem',
                        color: 'white',
                        fontWeight: 700,
                        zIndex: 2
                      }}>
                        {training.price}
                      </div>
                    )}
                  </div>

                  {/* Content - Title and Button with Proper Padding */}
                  <div style={{ 
                    padding: '16px 20px 20px 20px',
                    flex: 1, 
                    display: 'flex', 
                    flexDirection: 'column',
                    alignItems: 'center',
                    textAlign: 'center'
                  }}>
                    <h3 style={{
                      fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                      fontWeight: 700,
                      color: '#0A192F',
                      marginBottom: '4px',
                      lineHeight: '1.3'
                    }}>
                      {training.name}
                    </h3>

                    {training.instructor && (
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem',
                        marginBottom: '12px',
                        fontSize: '0.75rem',
                        color: '#5A6E7F'
                      }}>
                        <i className="fas fa-user-tie" style={{ color: '#2C7A7B' }}></i>
                        <span>{training.instructor}</span>
                      </div>
                    )}

                    <button
                      onClick={() => handleViewDetails(training)}
                      style={{
                        width: '100%',
                        marginTop: '0.5rem',
                        padding: '10px 16px',
                        background: 'linear-gradient(135deg, #F5A623 0%, #E67E22 100%)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '10px',
                        fontSize: '0.85rem',
                        fontWeight: 600,
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.5rem'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 4px 12px rgba(245,166,35,0.3)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      View Details <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      <style>{`
        @keyframes shimmer {
          0% { left: -100%; }
          100% { left: 100%; }
        }
      `}</style>
    </section>
  );
};

export default DynamicTraining;